module.exports = __webpack_public_path__ + "img/guide-done.f6d72fa6.svg";